export default "__VITE_ASSET__DAcKGBUJ__"